import React, { FunctionComponent, useState } from 'react';
import { TeamsFolderProps } from './types';
import { MeetingsSubFolder } from '../MeetingsSubFolder';
import { IMeetingSubFolder } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.types';
import { useParams } from 'react-router-dom';
import { IMeetingSimple } from '../../../../../app/resource/meeting-simple/meeting-simple.types';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingFilesSelectedSelectors } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.selectors';

export const MeetingsFolder: FunctionComponent<TeamsFolderProps> = ({ folder, onSelectChange }) => {
  const { meetingId } = useParams<{ meetingId: IMeetingSimple['id'] }>();
  const [selected, setSelected] = useState(false);
  const [openSubFolder, setOpenSubFolder] = useState(false);

  const [meetingShortcutsSelected] = useSelectWithParams(meetingFilesSelectedSelectors.selectResourceList, meetingId);

  return (
    <div>
      <div
        className={`panel small-panel flex aic px-1 mb-1 ${
          meetingShortcutsSelected && meetingShortcutsSelected.id === folder.id ? 'focus-title' : ''
        }`}
      >
        <i
          className={`icon2-play-small f-1  ${openSubFolder ? '' : 'blueGray'}`}
          onClick={() => setOpenSubFolder(!openSubFolder)}
          style={{ transform: `${openSubFolder ? 'rotate(90deg)' : 'rotate(0)'}` }}
        ></i>
        <button
          style={{ backgroundColor: '#fff' }}
          className=""
          title=""
          onClick={() => {
            const newSelected = !selected;
            setSelected(newSelected);
            onSelectChange(folder, newSelected);
          }}
        >
          <i className={`icon2-folder mr-1 ${openSubFolder ? 'darkGray' : 'blueGray'}`}></i> {folder.name}
        </button>
      </div>
      {openSubFolder &&
        folder?.subFolders?.map((subFolder: IMeetingSubFolder) => (
          <MeetingsSubFolder key={subFolder.id} subFolder={subFolder} onSelectChange={onSelectChange} />
        ))}
    </div>
  );
};
